import axios from "axios";

const state = {
  plz: "",
  windzone: "",
  standort: "",
  standorthoehe: "",
  lageExponiert: "",
  gebaeudehoehe: "",
  geschlossen: "",
  dachform: "",
  deckunterlage: "",
  dachneigung: "",
  trauflaenge: "",
  giebellaenge: "",
  walmtrauflaenge: "",
  walmneigung: "",
  pfannenmodell: "",
  windzonen: [],
  dachpfannen: [],
  lattung: "",
  windzonenObject: null,
  dachpfannenObject: null,
  windzoneGueltig: false,
  calculationResult: null,
  nutzungshinweise: false,
}

// getters
const getters = {
  isErlaubt(state) {
    if (state.lageExponiert == "true") return false;
    if (state.standorthoehe > 1100) return false;
    if (state.deckunterlage == "Keine Deckunterlage") return false;
    if (state.geschlossen == "false" && state.deckunterlage != "Geschlossene Deckunterlage" && state.deckunterlage != "") return false;
    return true;
  },
  isComplete(state) {
    if (state.dachform != "Walmdach") {
      if (state.dachform == "" || state.windzone == "" || state.standort == "" || state.standorthoehe == "" || state.lageExponiert == "" || state.gebaeudehoehe == "" || state.geschlossen == "" || state.deckunterlage == "" || state.dachneigung == "" || state.trauflaenge == "" || state.giebellaenge == "" || state.pfannenmodell == "", null || state.lattung == "" || !state.nutzungshinweise)
        return false;
      else
        return true
    } else {
      if (state.dachform == "" || state.windzone == "" || state.standort == "" || state.standorthoehe == "" || state.lageExponiert == "" || state.gebaeudehoehe == "" || state.geschlossen == "" || state.deckunterlage == "" || state.dachneigung == "" || state.trauflaenge == "" || state.walmtrauflaenge == "" || state.walmneigung == "" || state.pfannenmodell == "", null || state.lattung == "" || !state.nutzungshinweise)
        return false;
      else
        return true
    }

  },
  getWindzone: (state) => (state.windzone),
  getStandort: (state) => (state.standort),
  getStandorthoehe: (state) => (state.standorthoehe),
  getLageExponiert: (state) => (state.lageExponiert),
  getGebaeudehoehe: (state) => (state.gebaeudehoehe),
}

// actions
const actions = {
  changeLageExponiert({
    commit
  }, link) {
    commit("setActiveLink", link)
  },

  changeActiveContent({
    commit
  }, content) {
    commit("setActiveContent", content)
  },

  async getWindzonenFromApi({
    commit
  }) {
    if (navigator.onLine) { // true|false
      const response = await axios.get(process.env.VUE_APP_API_PATH + "/api/windzonen/token=Ag5h2$eU7jkrL5!i");

      commit("setWindzonen", response.data)

      localStorage.setItem("WindzonenDatenNeu", JSON.stringify(response.data))
    } else {
      //console.log("Windzonen konnten auf Grund fehlender Verbindung nicht angerufen werden!");
    }
  },

  getWindzonenFromStorage({
    commit
  }) {
    var data = localStorage.getItem("WindzonenDatenNeu")

    commit("setWindzonen", JSON.parse(data))
  },

  async getPfannenFromApi({
    commit
  }) {
    if (navigator.onLine) { // true|false
      const response = await axios.get(process.env.VUE_APP_API_PATH + "/api/dachpfannen/token=Ag5h2$eU7jkrL5!i");
      response.data.sort((a, b) => (a.hersteller > b.hersteller) ? 1 : ((b.hersteller > a.hersteller) ? -1 : 0));
      commit("setDachpfannen", response.data)
      localStorage.setItem("DachpfannenDaten", b64EncodeUnicode(JSON.stringify(response.data)))
    } else {
      //console.log("Pfannen konnten auf Grund fehlender Verbindung nicht abgerufen werden!");
    }
  },

  getPfannenFromStorage({
    commit
  }) {
    var data = localStorage.getItem("DachpfannenDaten")
    if (isJson(data)) {
      commit("setDachpfannen", JSON.parse(data))
      localStorage.removeItem("DachpfannenDaten");
      localStorage.setItem("DachpfannenDaten", b64EncodeUnicode(JSON.stringify(data)))
    } else {
      commit("setDachpfannen", JSON.parse(b64DecodeUnicode(data)))
    }

  },

  async updatePfannen({
    commit
  }) {
    if (navigator.onLine) { // true|false
      const response = await axios.get(process.env.VUE_APP_API_PATH + "/api/dachpfannen/token=Ag5h2$eU7jkrL5!i");
      response.data.sort((a, b) => (a.hersteller > b.hersteller) ? 1 : ((b.hersteller > a.hersteller) ? -1 : 0));
      var dataFromApi = JSON.stringify(response.data)
      var dataFromStorage = b64DecodeUnicode(localStorage.getItem("DachpfannenDaten"))
      if (dataFromApi != dataFromStorage) {
        commit("setDachpfannen", response.data)
        localStorage.setItem("DachpfannenDaten", b64EncodeUnicode(dataFromApi))
      }
    } else {
      // console.log("Berechnung wurde auf Grund fehlender Verbindung nicht gespeichert!");
    }
  },

  async postBerechnung() {
    if (navigator.onLine) { // true|false
      const instance = axios.create({
        baseURL: process.env.VUE_APP_API_PATH + '/api',
        crossDomain: true,
        timeout: 1000,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });
      instance.post('/berechnung', {
        plz: state.plz,
        windzone: state.windzone,
        standort: state.standort,
        standorthoehe: state.standorthoehe,
        gebaeudehoehe: state.gebaeudehoehe,
        geschlossen: state.geschlossen == "true" ? 1 : 0,
        dachform: state.dachform,
        deckunterlage: state.deckunterlage,
        dachneigung: state.dachneigung,
        trauflaenge: state.trauflaenge,
        giebellaenge: state.giebellaenge,
        trauflaengewalm: state.walmtrauflaenge,
        walmneigung: state.walmneigung,
        pfannenname: state.pfannenmodell,
        lattung: state.lattung,
        AnzahlKlammernGesamt: state.calculationResult.AnzahlKlammernGesamt,
        AnzahlKlammernKat1: state.calculationResult.AnzahlKlammernKat1,
        AnzahlKlammernKat2: state.calculationResult.AnzahlKlammernKat2,
        AnzahlKlammernKat3: state.calculationResult.AnzahlKlammernKat3,
        AnzahlKlammernKat4: state.calculationResult.AnzahlKlammernKat4,
        FlaecheDach: state.calculationResult.FlaecheDach,
        FlaecheKat1: state.calculationResult.FlaecheKat1,
        FlaecheKat1Grat: state.calculationResult.FlaecheKat1Grat,
        FlaecheKat1Walm: state.calculationResult.FlaecheKat1Walm,
        FlaecheKat2: state.calculationResult.FlaecheKat2,
        FlaecheKat3: state.calculationResult.FlaecheKat3,
        FlaecheKat4: state.calculationResult.FlaecheKat4,
        WindlastKategorie1Befestigung: state.calculationResult.WindlastKategorie1Befestigung,
        WindlastKategorie1BefestigungWalm: state.calculationResult.WindlastKategorie1BefestigungWalm,
        WindlastKategorie2Befestigung: state.calculationResult.WindlastKategorie2Befestigung,
        WindlastKategorie3Befestigung: state.calculationResult.WindlastKategorie3Befestigung,
        WindlastKategorie4Befestigung: state.calculationResult.WindlastKategorie4Befestigung,
        origin: "Luetfrink"
      })
      // .then(function (response) {
      //   console.log(response);
      // })
      // .catch(function (error) {
      //   console.err(error);
      // });
    } else {
      //console.log("Berechnung wurde auf Grund fehlender Verbindung nicht gespeichert!");
    }
  },

  setWindzonenObject({
    commit
  }) {
    if (state.plz.length == 5) {
      var gueltig = false;
      state.windzonen.forEach(function (objWindzone) {
        if (objWindzone.plz == state.plz) {
          commit("setWindzonenObject", objWindzone)
          commit("setWindzone", objWindzone.windzone)
          gueltig = true;
        }
      });
      if (gueltig)
        state.windzoneGueltig = true;
      else
        state.windzoneGueltig = false;
    }
  },
  setDachpfannenObject({
    commit
  }) {
    state.dachpfannen.forEach(function (objDachpfanne) {
      if (objDachpfanne.hersteller + ", " + objDachpfanne.name == state.pfannenmodell) {
        commit("setDachpfannenObject", objDachpfanne)
      }
    });
  },
}

// mutations
const mutations = {
  setLageExponiert: (state, value) => {
    state.lageExponiert = value
  },
  setStandorthoehe: (state, value) => {
    state.standorthoehe = value
  },
  setDeckunterlage: (state, value) => {
    state.deckunterlage = value
  },
  setGeschlossen: (state, value) => {
    state.geschlossen = value
  },
  setPlz: (state, value) => {
    state.plz = value
  },
  setWindzone: (state, value) => {
    state.windzone = value
  },
  setStandort: (state, value) => {
    state.standort = value
  },
  setGebaeudehoehe: (state, value) => {
    state.gebaeudehoehe = value
  },
  setDachform: (state, value) => {
    state.dachform = value
  },
  setDachneigung: (state, value) => {
    state.dachneigung = value
  },
  setTrauflaenge: (state, value) => {
    state.trauflaenge = value
  },
  setGiebellaenge: (state, value) => {
    state.giebellaenge = value
  },
  setWalmtrauflaenge: (state, value) => {
    state.walmtrauflaenge = value
  },
  setWalmneigung: (state, value) => {
    state.walmneigung = value
  },
  setPfannenmodell: (state, value) => {
    state.pfannenmodell = value
  },
  setLattung: (state, value) => {
    state.lattung = value
  },
  setWindzonen: (state, value) => {
    state.windzonen = value
  },
  setWindzonenObject: (state, value) => {
    state.windzonenObject = value
  },
  setDachpfannen: (state, value) => {
    state.dachpfannen = value.sort((a, b) => {
      if(a.hersteller > b.hersteller) {
        return 1;
      }
      else if(a.hersteller < b.hersteller) {
        return -1;
      }
      else if(a.hersteller == b.hersteller) {
        if(a.name > b.name) {
          return 1;
        }
        else if(a.name < b.name) {
          return -1;
        }
      }
      else return 1;
   })
  },
  setDachpfannenObject: (state, value) => {
    state.dachpfannenObject = value
  },
  setCalculationResult: (state, value) => {
    state.calculationResult = value
  },
  setNutzungshinweise: (state, value) => {
    state.nutzungshinweise = value
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}

function b64EncodeUnicode(str) {
  // first we use encodeURIComponent to get percent-encoded UTF-8,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
    function toSolidBytes(match, p1) {
      return String.fromCharCode('0x' + p1);
    }));
}

function b64DecodeUnicode(str) {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(atob(str).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
}

function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}